module.exports = __webpack_public_path__ + "img/logement-ouest.282a7492.png";